import { HttpClient, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../environments/environment.service';

@Injectable({
  providedIn: 'root',
})
export class EiImportService {
  private readonly http = inject(HttpClient);

  private readonly uploadUrl = `${inject(EnvironmentService).mbusParserService}/els`;

  uploadElsFile(file: File, kek: string): Observable<HttpEvent<unknown>> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.uploadUrl}?kek=${kek}`, formData, { reportProgress: true, observe: 'events', responseType: 'blob' });
  }
}
